<template>
  <div>
    <!-- pc版本 -->
    <div class="power-wrap" id="power">
      <!-- <div style="height:1000px;background-color: red;">111</div> -->
      <div class="power-con">
        <div class="title">{{ title }}</div>
        <div class="contract-info">
          <div class="btn-info" data-wow-delay="100ms">
            <div
              v-for="(item, index) in btnList"
              @click="activefuns(index)"
              :class="['item', activeIndex == index ? 'active' : '']"
              :key="index"
            >
              <div class="text">{{ item.name }}</div>
              <div class="line"></div>
            </div>
          </div>
          <div v-for="(item, index) in powerList" :key="index" :class="['power-item', 'fadeIn', activeIndex == index ? 'active' : '']">
            <div class="img-wrapper"><img class="img" :src="item.imgSrc" /></div>
            <div class="right">
              <div class="des" v-for="(subitem, subindex) in item.desList" :key="subindex">
                <div class="title">{{ subitem.title }}</div>
                <div class="text">{{ subitem.des }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="right wow fadeIn" data-wow-delay="100ms">
			<div class="righti lbright">
				<img src="/images/showService-bigImg.png" alt="" />
				<img src="/images/showService-bigImg2.png" alt="" />
				<img src="/images/showService-bigImg3.png" alt="" />
				<img src="/images/showService-bigImg4_21_6_11.png" alt="" />
				<img src="/images/showService-bigImg5.png" alt="" />
			</div>
		</div> -->
    </div>
    <!-- h5版本 -->
    <div class="power-wrap-mobile" id="power">
      <div class="title">{{ title }}</div>
      <div class="btn-info" data-wow-delay="100ms">
        <div class="btn-con">
          <div
            v-for="(item, index) in btnList"
            @click="activefuns(index)"
            :class="['item', activeIndex == index ? 'active' : '']"
            :key="index"
          >
            <div class="text">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div
        v-for="(item, index) in powerList"
        :key="index"
        :class="['power-item', 'fadeIn', activeIndex == index ? 'power-item-active' : '']"
      >
        <img class="img" :src="item.imgSrc" />
        <div class="des" v-for="(subitem, subindex) in item.desList" :key="subindex">
          <div class="title">{{ subitem.title }}</div>
          <div class="text">{{ subitem.des }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    powerList: Array,
    btnList: Array,
  },
  data() {
    return {
      timer: '',
      activeIndex: 0,
    }
  },
  created() {
    this.activefun()
  },
  methods: {
    activefuns(index) {
      // if (window.innerWidth < 1024) return
      clearInterval(this.timer)
      this.activeIndex = index
      this.timer = setInterval(() => {
        this.activeIndex++
        if (this.activeIndex >= 5) {
          this.activeIndex = 0
        }
      }, 6000)
    },
    activefun() {
      if (window.innerWidth < 1024) return
      setTimeout(() => {
        this.activeIndex++
        if (this.activeIndex >= 5) {
          this.activeIndex = 0
        }
      })
      this.timer = setInterval(() => {
        this.activeIndex++
        if (this.activeIndex >= 5) {
          this.activeIndex = 0
        }
      }, 5000)
    },
  },
  computed: {},
}
</script>

<style lang="less" scoped>
@media screen and (min-width: 768px) {
  .power-wrap-mobile {
    display: none;
  }
  .power-wrap {
    background-color: #fafafc;
    padding: 51px 0 70px;
    height: 780px;
    .power-con {
      max-width: 1400px;
      height: 100%;
      margin: 0 auto;
      // position: relative;
      .title {
        font-size: 40px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #230606;
        line-height: 56px;
        text-align: center;
      }
      .contract-info {
        padding-top: 70px;
        width: 100%;
        height: 100%;
        position: relative;
        .power-item {
          position: absolute;
          visibility: hidden;
          opacity: 0;
          transition: all 0.4s ease-in-out;
          transform: scale(0.98) translateY(4%);
          display: flex;
          border: 1px solid #eeeeee;
          padding: 20px 40px;
          .img-wrapper {
            width: 53%;
            margin-right: 95px;
            display: flex;
            align-items: center;
          }
          .img {
          }
          .right {
            width: 446px;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-top: 28px;
            .des {
              width: 100%;
              margin-bottom: 40px;
              .title {
                font-size: 20px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #202640;
                line-height: 28px;
                margin-bottom: 10px;
                text-align: left;
              }
              .text {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #202640;
                line-height: 26px;
                text-align: left;
              }
            }
          }
        }
        .active {
          visibility: visible;
          opacity: 1;
          transform: scale(1) translateY(0px);
        }
      }
      .btn-info {
        display: flex;
        align-items: center;
        justify-content: space-around;
        max-width: 800px;
        margin: 0 auto;

        .item {
          padding: 20px 10px;
          display: flex;
          align-items: center;
          flex-direction: column;
          justify-content: center;
          z-index: 1;
          cursor: pointer;

          .text {
            font-size: 16px;
            font-weight: 400;
            color: #202640;
            line-height: 22px;
          }
          .title {
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #202640;
            line-height: 22px;
          }
          .line {
            width: 0%;
            height: 3px;
            background-color: #e61717;
            position: absolute;
            left: 0;
            bottom: 0;
          }
          &:hover {
            .text {
              color: #e61717;
            }
          }
        }
        .active {
          transform: scale(1.1);
          z-index: 2;
          .line {
            // transition: all 5s linear;
            width: 100%;
          }
          .text {
            font-size: 16px;
            font-weight: 400;
            line-height: 22px;
            color: #e61717;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .power-wrap {
    display: none;
  }
  .power-wrap-mobile {
    background-color: #fafafc;
    padding-top: 1.0667rem;
    padding-bottom: 1.0667rem;
    .title {
      font-size: 0.5867rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 0.5867rem;
      text-align: center;
    }
    .btn-info {
      margin-top: 1.0667rem;
      padding-left: 0.4rem;
      border-bottom: 1px solid #eeeeee;
      width: 100%;
      overflow: auto;
      white-space: nowrap;
      .btn-con {
        width: auto;
      }
      .item {
        display: inline-block;
        vertical-align: middle;
        font-size: 0.48rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #202640;
        line-height: 0.6667rem;
        margin-right: 0.8rem;
        padding-bottom: 0.2667rem;
      }
      .active {
        position: relative;
        &::after {
          content: '';
          position: absolute;
          width: 1.7067rem;
          height: 0.08rem;
          background: #e61717;
          left: 0;
          bottom: 0;
        }
      }
    }
    .power-item {
      display: none;
      padding: 0.3733rem 0.4rem 0;
      .img {
        width: 100%;
        height: 5.6533rem;
      }
      .des {
        .title {
          margin-top: 0.8rem;
          font-size: 0.48rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #202640;
          line-height: 0.6667rem;
        }
        .text {
          font-size: 0.3733rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #202640;
          line-height: 0.64rem;
          margin-top: 0.2667rem;
        }
      }
    }
    .power-item-active {
      display: block;
    }
  }
}
.fadeIn {
  animation-delay: 100ms;
  animation-name: fadeIn;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
